import React, { useState, useRef, FocusEvent } from "react";
import { Form, Button } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { ChangeAuthenticationUIActionTypes, dayjs, GlobalConstants } from "src/common";
import { CountdownDisplay, VerificationCode } from "src/components";

type AllProps = {
  expires_param?: string;
  handleAction: ActionHandlerFunction;
  title: string;
}

function SMSCodeVerificationFormComponent(props: AllProps) {
  const { expires_param, handleAction, title } = props;
  const expires = !!expires_param ? expires_param : dayjs().add(GlobalConstants.LOGIN_VERIFICATION_CODE_VALID, "minutes").format("YYYY-MM-DD HH:mm:ss");
  const [expired, setExpired] = useState<boolean>(false);
  const button_ref = useRef<HTMLButtonElement>(null);
  let secret = "";

  // Description: Validate and set secret code on finished
  function handleSetSecretCode(code: string) {
    secret = code;
    const button = button_ref.current;
    const is_valid = code.length === GlobalConstants.CREATE_ACCOUNT_VERIFICATION_CODE_MAX;
    if (!!button) {
      button.disabled = !is_valid;
      is_valid && setTimeout(() => button.focus());
    }
    is_valid && handleSubmit();
  }

  // Description: Handle form submit
  function handleSubmit() {
    handleAction({ actionType: ChangeAuthenticationUIActionTypes.SubmitSMSVerificationCode, params: secret });
  }

  // Description: Expiration Message Panel
  function VerificationCodeExpired() {
    return <>
      <p>
        The verification code that we sent in a SMS message has expired. Please click <b>Back</b> to restart the process.
      </p>
      <div className="btn-panel">
        <Button variant="outline-secondary" type="button"
          onClick={() => handleAction({ actionType: ChangeAuthenticationUIActionTypes.ResetForms })}>Back</Button>
      </div>
    </>;
  }

  // Description: Render the enter code
  function VerificationForm() {
    return <>
      <h3 className="border-bottom">{title}</h3>
      <p>We sent you an SMS message with a verification code. Please enter it below.</p>
      <p>This code will expire in <b><CountdownDisplay expires={expires} handleTimeExpired={() => setExpired(true)} /></b>.</p>
      <Form onSubmit={(e: FocusEvent<HTMLFormElement>) => {
        e.stopPropagation();
        e.preventDefault();
        handleSubmit();
      }} noValidate>
        <Form.Group className="mb-3" >
          <Form.Label>Verification Code</Form.Label>
          <VerificationCode count={GlobalConstants.CREATE_ACCOUNT_VERIFICATION_CODE_MAX} handleAction={handleSetSecretCode} />
          <Form.Text>
            Did not get an SMS message with your code? <Button type="button" variant="link" size="sm" className="fs-6"
              onClick={() => handleAction({
                actionType: ChangeAuthenticationUIActionTypes.SubmitPhone,
                params: { expires: dayjs().add(15, "minutes") }
              })}>Resend code</Button>
          </Form.Text>
        </Form.Group>
        <div className="btn-panel">
          <Button type="submit" ref={button_ref} disabled={true} >Verify</Button>
          <Button variant="outline-secondary" type="button"
            onClick={() => handleAction({ actionType: ChangeAuthenticationUIActionTypes.ResetForms })}>Cancel</Button>
        </div>
      </Form>
    </>;
  }

  return expired ? <VerificationCodeExpired /> : <VerificationForm />;
}
export default React.memo(SMSCodeVerificationFormComponent);
